import { Checkout } from './Checkout';
import { Compliance } from './Compliance';
import { Account } from './Account';
import { General } from './General';

export const ConfigMappings = {
    ...General,
    ...Account,
    ...Checkout,
    ...Compliance
};
